import { useAppSelector } from 'hooks/redux';
import React, { useMemo } from 'react';

import Checkbox from '@mui/material/Checkbox';
import Typography from '@mui/material/Typography';

import ExpandableCard from 'components/ExpandableCard';
import MuiTagsField from 'components/QuickenControls/TagsField/TagsField';

import { tagsSelectors } from 'app-components/flux/tags';
import type { Tag } from 'app-components/flux/tags/tagsTypes';
import { useField } from 'app-components/flux/transaction-rules/transactionRulesFormHooks';

import useStyles from '../styles';

function TagsTarget() {
  const { cx, classes } = useStyles();
  const { value, onValueChange, error } = useField('tagsTarget');

  const allTagsById = useAppSelector(tagsSelectors.getTags);

  const tags = useMemo(() => {
    const tagIds = value || [];
    return allTagsById.filter((tag) => tag.id && tagIds.includes(tag.id));
  }, [allTagsById, value]);

  const tagsValue = tags.toArray().map(([_, tagRecord]: [string, Tag]) => tagRecord);

  return (
    <>
      <MuiTagsField
        value={tagsValue}
        onChange={(_e, tagArray, _reason, _details) => {
          const ids: string[] = tagArray
            .map((tag: any) => {
              const id = typeof tag?.get === 'function' ? tag.get('id') : tag.id;
              return id;
            })
            .filter((id): id is string => typeof id === 'string');
          onValueChange(ids);
        }}
        id='rule-tags-target'
        limitTags={-1}
        className={cx(classes.tagsFieldContainer, error ? classes.errorBorder : '')}
      />
      {error && (
        <Typography variant='captionRegular' className={classes.errorText}>
          Required
        </Typography>
      )}
    </>
  );
}

export function TagsTargetCard(props: any) {
  const { classes, theme } = useStyles();
  const { value, onValueChange } = useField('isEnabledTagsTarget');

  return (
    <ExpandableCard
      id='rule-tags-target'
      className={classes.card}
      title='Add Tags'
      cardHeaderProps={{ padding: `${theme.spacing(1.5)} ${theme.spacing(2)}` }}
      titleProps={{ variant: 'subtitle2' }}
      expandIcon={
        <Checkbox id='rule-tags-target-enabled' checked={value} onChange={(_, checked) => onValueChange(checked)} />
      }
      isExpanded={value || !!props.hideToggle}
      hideToggle={!!props.hideToggle}
      onExpandedChange={onValueChange}
    >
      <TagsTarget />
    </ExpandableCard>
  );
}
